import React, {useCallback, useMemo, useState} from 'react';
import {Box} from '@mui/material';
import ArrTileSelection, {
  getSelectedTotal,
} from '../../../components/common/arr-tile-selection/ArrTileSelection';

const SPACING_16 = '1rem';
const SPACING_12 = '0.75rem';

const TileSelectionDemo: React.FC = () => {
  const [tiles, setTiles] = useState([
    {id: 'hits', label: 'Hits', total: 10000, selected: true, disabled: false},
    {
      id: 'family',
      label: 'Family Members',
      total: 100000,
      selected: true,
      disabled: false,
    },
    {
      id: 'nearDupes',
      label: 'Near Dupes',
      total: 10000,
      selected: false,
      disabled: false,
    },
    {
      id: 'emailThreaded',
      label: 'Email Threaded',
      total: 0,
      selected: false,
      disabled: true,
    },
    {
      id: 'uniqueHits',
      label: 'Unique Hits',
      total: 0,
      selected: false,
      disabled: true,
    },
  ]);

  const handleToggle = useCallback((id: string, selected: boolean) => {
    setTiles((prev) =>
      prev.map((tile) => (tile.id === id ? {...tile, selected} : tile))
    );
  }, []);

  // Compute the total of all selected tiles
  const totalSelected = useMemo(() => getSelectedTotal(tiles), [tiles]);

  // Format the number for display (e.g., 100,000)
  const formattedTotal = useMemo(
    () =>
      new Intl.NumberFormat(undefined, {maximumFractionDigits: 0}).format(
        totalSelected
      ),
    [totalSelected]
  );

  return (
    <Box sx={{padding: SPACING_16}} data-testid="tile-selection-demo">
      {/* Summary banner, announced to assistive tech on change */}
      <Box sx={{marginBottom: SPACING_12}} aria-live="polite">
        <strong>Selected total:</strong> {formattedTotal}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: SPACING_12,
        }}
        data-testid="tile-grid"
      >
        {tiles.map((tile) => (
          <ArrTileSelection
            key={tile.id}
            label={tile.label}
            total={tile.total}
            selected={tile.selected}
            disabled={tile.disabled}
            ariaLabel={`Tile for ${tile.label}`}
            onToggle={(selected) => handleToggle(tile.id, selected)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TileSelectionDemo;
